<template>
    <div v-show='product.product'>
        <div v-if='in_stock' class="product-quantity-change-container" :class="{'product-quantity-changer':product.typeid == '4' || product.typeid == '8'}">
            <QuantityChanger theme='primary_colour' v-show='product.typeid != 4' :product='product' button_text='Add Cases' unit_type='cases' @updatedCartListener="updatedCartListener"/>
            <QuantityChanger theme='green' v-show='product.typeid != 8' :product='product' :button_text="product.typeid == '4' ? 'Add' : 'Add bottles'"  @updatedCartListener="updatedCartListener"/>
        </div>
    </div>
</template>
<script>
import QuantityChanger from '@/ecom/components/products/QuantityChanger.vue';

export default {
    components: {QuantityChanger},
    emits: ['updatedCartListener'],
    props: ['product', 'in_stock'],
    methods:{
        updatedCartListener(){
            this.$emit('updatedCartListener');
        }
    }
}
</script>
<style lang="scss" scoped>
.add-to-cart{
    margin-top: 30px;
}
.spaced{
    margin-bottom: 20px;
}
.product-quantity-change-container{
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 10px;
}
.product-quantity-changer{
    margin-top: 30px;
}
</style>